/**
 * The seven kinds of thing a tool can do, in the order the product shows them. One list, with no
 * imports, so the database schema and the connections contract state the same vocabulary.
 * `actionCategorySchema` in `@typedoc/contracts/connections` is built from it.
 */
export const ACTION_CATEGORY_LIST = [
  "look",
  "change",
  "send",
  "money",
  "settings",
  "delete",
  "others",
] as const;
